module.exports = __webpack_public_path__ + "media/fyt_m18.82d8f03d.mp4";